/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChallengeOnboardingDetails
 */
export interface ChallengeOnboardingDetails {
    /**
     * 
     * @type {string}
     * @memberof ChallengeOnboardingDetails
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof ChallengeOnboardingDetails
     */
    description: string;
}

/**
 * Check if a given object implements the ChallengeOnboardingDetails interface.
 */
export function instanceOfChallengeOnboardingDetails(value: object): value is ChallengeOnboardingDetails {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function ChallengeOnboardingDetailsFromJSON(json: any): ChallengeOnboardingDetails {
    return ChallengeOnboardingDetailsFromJSONTyped(json, false);
}

export function ChallengeOnboardingDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeOnboardingDetails {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'description': json['description'],
    };
}

export function ChallengeOnboardingDetailsToJSON(json: any): ChallengeOnboardingDetails {
    return ChallengeOnboardingDetailsToJSONTyped(json, false);
}

export function ChallengeOnboardingDetailsToJSONTyped(value?: ChallengeOnboardingDetails | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'description': value['description'],
    };
}

